import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import Toast from 'react-native-toast-message';
import { useTheme } from './ThemeContext';
import { toastConfig } from '../config/toast';

type NotificationContextType = {
  showToast: (type: 'success' | 'error' | 'info', message: string, description?: string) => void;
};

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const { theme } = useTheme();

  const showToast = (
    type: 'success' | 'error' | 'info',
    message: string,
    description?: string
  ) => {
    Toast.show({
      type: type,
      text1: message,
      text2: description,
      position: 'top',
      visibilityTime: 4000,
      autoHide: true,
      topOffset: 50,
    });
  };

  const value = {
    showToast,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <Toast config={toastConfig} />
    </NotificationContext.Provider>
  );
}; 